// src/features/boe/components/programs/Program0600.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_0600_CONFIG = {
    fullName: "SCIENCE",
    docId: "0600",

    fieldDefs: [
      // POSITIONS (FTE)
      {
        key: "positionsAdmin",
        label: "Positions – Administrative",
        valueType: "count",
        sources: [{ block: "Positions", key: "Administrative" }],
        group: "positions",
        defaultVisible: false,
      },
      {
        key: "positionsTeachers",
        label: "Positions – Teachers",
        valueType: "count",
        sources: [{ block: "Positions", key: "Teachers" }],
        group: "positions",
        defaultVisible: false,
      },
      {
        key: "positionsParaeducators",
        label: "Positions – Paraeducators",
        valueType: "count",
        sources: [
          { block: "Positions", key: "Paraeducators" },
          { block: "Positions", key: "Paraeducators" }, // fallback if any odd spelling
        ],
        group: "positions",
        defaultVisible: false,
      },

      // SALARIES
      {
        key: "salariesAdmin",
        label: "Salaries – Administrative",
        valueType: "currency",
        sources: [
          { block: "Salaries", key: "Administrative" },
        ],
        group: "salaries",
        defaultVisible: false,
      },
      {
        key: "salariesTeachers",
        label: "Salaries – Teachers",
        valueType: "currency",
        sources: [
          { block: "Salaries", key: "Teachers" },
          { block: "Salaries", key: "Teachers (Science)" }, // future oddball safety
        ],
        group: "salaries",
        defaultVisible: false,
      },
      {
        key: "salariesParaeducators",
        label: "Salaries – Paraeducators",
        valueType: "currency",
        sources: [
          { block: "Salaries", key: "Paraeducators" },
        ],
        group: "salaries",
        defaultVisible: false,
      },
      {
        key: "salariesTutorCrestLab",
        label: "Salaries – Tutor Crest Lab",
        valueType: "currency",
        sources: [
          { block: "Salaries", key: "Tutor Crest Lab" },
          { block: "Salaries", key: "Tutor Crest LAB" },
        ],
        group: "salaries",
        defaultVisible: false,
      },

      // Field Trips (kept with salaries, like 0500)
      {
        key: "fieldTrips",
        label: "Field Trips",
        valueType: "currency",
        sources: [
          { block: "Salaries", key: "Field Trips" },
          { block: "Supplies / Materials", key: "Field Trips" }, // just in case
        ],
        group: "salaries",
        defaultVisible: false,
      },

      // PURCHASED SERVICES
      {
        key: "purchasedTransportMentor",
        label: "Transport/Mentor Program",
        valueType: "currency",
        sources: [
          { block: "Purchased Services", key: "Transport / Mentor Program" },
          { block: "Purchased Services", key: "Transportation/Mentor Program" },
          { block: "Purchased Services", key: "TRANSPORTATION/MENTOR PROGRAM" },
        ],
        group: "purchasedServices",
        defaultVisible: false,
      },
      {
        key: "purchasedPrinting",
        label: "Printing",
        valueType: "currency",
        sources: [
          { block: "Purchased Services", key: "Printing" },
          { block: "Purchased Services", key: "PRINTING" },
        ],
        group: "purchasedServices",
        defaultVisible: false,
      },

      // SUPPLIES / MATERIALS
      {
        key: "instructionalMaterials",
        label: "Instructional Materials",
        valueType: "currency",
        sources: [
          { block: "Supplies / Materials", key: "Instructional Materials" },
          {
            block: "Supplies / Materials",
            key: "Instructional Materials (Science)",
          },
        ],
        group: "materials",
        defaultVisible: false,
      },
      {
        key: "technologySoftware",
        label: "Technology – Software",
        valueType: "currency",
        sources: [
          { block: "Supplies / Materials", key: "Technology Software" },
          { block: "Supplies / Materials", key: "Technology - Software" },
        ],
        group: "materials",
        defaultVisible: false,
      },

      // OTHER
      {
        key: "duesFees",
        label: "Dues / Fees",
        valueType: "currency",
        sources: [
          { block: "Other", key: "Dues and Fees" },
          { block: "Other", key: "Dues/Fees" },
          { block: "Other", key: "Dues / Fees" },
        ],
        group: "other",
        defaultVisible: false,
      },
    ],

    tables: [
      {
        id: "approved",
        title: "Approved Budget",
        sectionKey: "Approved",
        fields: [
          // Positions
          "positionsAdmin",
          "positionsTeachers",
          "positionsParaeducators",

          // Salaries
          "salariesAdmin",
          "salariesTeachers",
          "salariesParaeducators",
          "salariesTutorCrestLab",
          "fieldTrips",

          // Purchased Services
          "purchasedTransportMentor",
          "purchasedPrinting",

          // Supplies / Materials
          "instructionalMaterials",
          "technologySoftware",

          // Other
          "duesFees",
        ],
        columnStyles: {
          year: { width: "100px", minWidth: "100px" },

          // Positions
          positionsAdmin: { minWidth: "120px" },
          positionsTeachers: { minWidth: "110px" },
          positionsParaeducators: { minWidth: "150px" },

          // Salaries
          salariesAdmin: { minWidth: "130px" },
          salariesTeachers: { minWidth: "120px" },
          salariesParaeducators: { minWidth: "150px" },
          salariesTutorCrestLab: { minWidth: "140px" },

          fieldTrips: { minWidth: "90px" },

          // Purchased Services
          purchasedTransportMentor: { minWidth: "180px" },
          purchasedPrinting: { minWidth: "110px" },

          // Supplies / Materials
          instructionalMaterials: { minWidth: "140px" },
          technologySoftware: { minWidth: "150px" },

          // Other
          duesFees: { minWidth: "110px" },
        },
      },
      {
        id: "actual",
        title: "Actual Spending",
        sectionKey: "Actual",
        fields: [
          // Positions
          "positionsAdmin",
          "positionsTeachers",
          "positionsParaeducators",

          // Salaries
          "salariesAdmin",
          "salariesTeachers",
          "salariesParaeducators",
          "salariesTutorCrestLab",
          "fieldTrips",

          // Purchased Services
          "purchasedTransportMentor",
          "purchasedPrinting",

          // Supplies / Materials
          "instructionalMaterials",
          "technologySoftware",

          // Other
          "duesFees",
        ],
        columnStyles: {
          year: { width: "100px", minWidth: "100px" },

          // Positions
          positionsAdmin: { minWidth: "120px" },
          positionsTeachers: { minWidth: "110px" },
          positionsParaeducators: { minWidth: "150px" },

          // Salaries
          salariesAdmin: { minWidth: "130px" },
          salariesTeachers: { minWidth: "120px" },
          salariesParaeducators: { minWidth: "150px" },
          salariesTutorCrestLab: { minWidth: "140px" },

          fieldTrips: { minWidth: "90px" },

          // Purchased Services
          purchasedTransportMentor: { minWidth: "180px" },
          purchasedPrinting: { minWidth: "110px" },

          // Supplies / Materials
          instructionalMaterials: { minWidth: "140px" },
          technologySoftware: { minWidth: "150px" },

          // Other
          duesFees: { minWidth: "110px" },
        },
      },
    ],
  };

export function Program0600(props) {
  return (
    <ProgramBudget programId="0600" config={PROGRAM_0600_CONFIG} {...props} />
  );
}
